import {
  SET_IN_PROGRESS,
  SET_LAST_REQUESTED_TIME,
  SET_LAST_INTERACTION_TIME,
  SET_XSRF_TOKEN,
  SET_IN_PROGRESS_FOR_COMPONENT,
  SET_SYSTEM_UNAVAILABLE,
  SET_VERSION_INCOMPATIBLE,
  SET_LOGGED_OUT
} from "../actions/networkStateActions";

const initialState = {
  inProgress: false,
  inProgressForComponent: false
};

export default function networkStateReducer(state = initialState, action) {
  switch (action.type) {
    case SET_IN_PROGRESS:
      return {
        ...state,
        inProgress: action.payload
      };
    case SET_IN_PROGRESS_FOR_COMPONENT:
      return {
        ...state,
        inProgressForComponent: action.payload
      };
    case SET_LAST_REQUESTED_TIME:
      return {
        ...state,
        lastRequestedTime: action.payload
      };
    case SET_LAST_INTERACTION_TIME:
      return {
        ...state,
        lastInteractionTime: action.payload
      };
    case SET_XSRF_TOKEN:
      return {
        ...state,
        xsrfToken: action.payload
      };
    case SET_SYSTEM_UNAVAILABLE:
      return {
        ...state,
        systemUnavailable: action.payload
      };
    case SET_VERSION_INCOMPATIBLE:
      return {
        ...state,
        versionIncompatible: action.payload
      };
    case SET_LOGGED_OUT:
      return {
        ...state,
        isLoggedOut: action.payload
      };
    default:
      return state;
  }
}
